import type { IconProps } from './../../models/icon';

export function HeartIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M14.1698 20.4127C12.949 21.6223 11.0583 21.6223 9.83744 20.4127L2.55646 13.1992C-2.31439 8.32822 4.04607 -2.43343 12.0036 5.52413C19.9472 -2.41944 26.3077 8.34238 21.4508 13.1992L14.1698 20.4127Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M14.1698 20.4127C12.949 21.6223 11.0583 21.6223 9.83744 20.4127L2.55646 13.1992C-2.31439 8.32822 4.04607 -2.43343 12.0036 5.52413C19.9472 -2.41944 26.3077 8.34238 21.4508 13.1992L14.1698 20.4127Z"
      />
    </svg>
  );
}
